import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SourceFlowForm from '@sourceflow-uk/sourceflowform';
import imageMetaData from "../../.sourceflow/image_metadata.json";
import {
    Container,
    Col,
    Row,
    CardImg,
    Card,
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"

export default function SimpleContent({
    global,
    pathPrefix,
    customClass = "",
    content,
    editableText = true,
    buttonTitle1 = "",
    buttonTitleLink1 = "",
    imageURL,
}) {

    return (
        <>
            {
                content ?
                    <section className={`${styles.root} ${customClass}`}>
                        <Container>
                            <Row className={`align-items-center`}>
                                <Col md={imageURL ? 7 : 12} className="pe-md-5">
                                    {content ?
                                        editableText ?
                                            <div className="mainContent">
                                                <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                                    {content}
                                                </SourceFlowText>
                                            </div> : <div className="mainContent">{content}</div> : ""}
                                    {buttonTitleLink1 ?
                                        <div>
                                            <Link href={`${buttonTitleLink1}`}>
                                                <a className="primaryBtn no-arrow">
                                                    <SourceFlowText global={global} path={`${pathPrefix}.buttonTitle1`} >
                                                        {buttonTitle1}
                                                    </SourceFlowText>
                                                </a>
                                            </Link>
                                        </div> : null}
                                </Col>
                                {imageURL &&
                                    <Col md={5} className="ps-md-5 mb-5 mb-md-0">
                                        <SourceFlowImage
                                            src={imageURL ? imageURL : "/site-assets/placeholders/img-placeholder.jpg"}
                                            size="1000x"
                                            alt="Featured Image"
                                            className="card-img rounded-4"
                                            imagesMetaData={imageMetaData}
                                            path={pathPrefix ? pathPrefix : (`${pathPrefix}.image`) }
                                            />
                                    </Col>
                                }
                            </Row>
                        </Container>
                    </section > : ""}
        </>

    )
}